/* ─── Root ─── */

.root {
  font-family: var(--font-sans);
}

/* ─── List ─── */

.list {
  composes: scrollerX from "../../shared.module.css";
  position: relative;
  border-block-end: 1px solid var(--md-outline-variant);
}

.root[data-orientation="vertical"] .list {
  flex-direction: column;
  border-block-end: none;
  border-inline-end: 1px solid var(--md-outline-variant);
  min-width: 10rem;
  overflow-x: visible;
  overflow-y: auto;
}

/* ─── Tab ─── */

.tab {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  padding-inline: var(--space-4);
  font-family: inherit;
  font-weight: 600;
  color: var(--md-on-surface-variant);
  background: transparent;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  transition: color var(--motion-duration-short3) var(--motion-easing-standard);
}

.tab::before {
  content: "";
  position: absolute;
  inset: 0;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .tab:hover::before {
    opacity: var(--state-hover);
  }
}

.tab:focus-visible::before {
  opacity: var(--state-focus);
}

.tab:active::before {
  opacity: var(--state-pressed);
}

.tab[data-selected] {
  color: var(--md-primary);
}

.tab[data-disabled] {
  opacity: 0.38;
  cursor: not-allowed;
}

/* ─── Panel ─── */

.panel {
  padding: var(--space-4) 0;
  outline: none;
}

.panel[data-hidden] {
  display: none;
}

/* ─── Indicator ─── */

.indicator {
  position: absolute;
  bottom: 0;
  left: var(--active-tab-left);
  width: var(--active-tab-width);
  height: 3px;
  background: var(--md-primary);
  border-radius: var(--shape-full) var(--shape-full) 0 0;
  transition: left var(--motion-duration-medium1) var(--motion-easing-standard),
    width var(--motion-duration-medium1) var(--motion-easing-standard),
    top var(--motion-duration-medium1) var(--motion-easing-standard),
    height var(--motion-duration-medium1) var(--motion-easing-standard);
}

.root[data-orientation="vertical"] .indicator {
  bottom: auto;
  left: auto;
  inset-inline-end: 0;
  top: var(--active-tab-top);
  width: 3px;
  height: var(--active-tab-height);
}
